// SlotMachine.js
import React, {useEffect, useState} from 'react';
import {createTheme, ThemeProvider} from '@mui/material/styles';
import AppBar from '@mui/material/AppBar';
import CssBaseline from '@mui/material/CssBaseline';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import GlobalStyles from '@mui/material/GlobalStyles';
import Container from '@mui/material/Container';
import Checkbox from '@mui/material/Checkbox';
import Reel from './Reel';
import SpinButton from './SpinButton';
import CommentArea from './CommentArea';
import Copyright from './Copyright'
import './App.css';
import reelsText from './reelsText.json';
import ssText from './ssText.json';

function SlotMachine() {

    const initialSymbols = () => {
        const symbols = ['1', '2', '3', '4', '5', '6'];
        return symbols.concat(symbols).concat(symbols).concat(symbols).concat(symbols).concat(symbols).concat(symbols);
    };
    const fixReelResult = (array) => {
        const newArray = [...array];
        const indexThree = newArray.indexOf('3');
        const secondElement = newArray[1];

        newArray[1] = '3';
        newArray[indexThree] = secondElement;
        return newArray;
    };
    const generateSymbols = (fix) => {
        const symbols = ['1', '2', '3', '4', '5', '6'];
        const shuffledSymbols = shuffle(symbols);
        const nextSymbols = fix ? fixReelResult(shuffledSymbols): shuffledSymbols;
        return nextSymbols.concat(nextSymbols).concat(nextSymbols).concat(nextSymbols).concat(nextSymbols).concat(nextSymbols).concat(nextSymbols);
    };
    const shuffle = (array) => {
        var currentIndex = array.length, temporaryValue, randomIndex;
        while (0 !== currentIndex) {
            randomIndex = Math.floor(Math.random() * currentIndex);
            currentIndex -= 1;
            temporaryValue = array[currentIndex];
            array[currentIndex] = array[randomIndex];
            array[randomIndex] = temporaryValue;
        }
        return array;
    };

    const payline = (symbols) => {
        return symbols.map((symbol, rowIndex) => reelsTextMap.get(`${rowIndex + 1}_${symbol[1]}`))
    };

    const paylineSs = (symbols) => {
        return ssTextMap.get(`${symbols[0][1]}-${symbols[1][1]}-${symbols[2][1]}-${symbols[3][1]}`)
    };
    const [reel1, setReel1] = useState(initialSymbols());
    const [reel2, setReel2] = useState(initialSymbols());
    const [reel3, setReel3] = useState(initialSymbols());
    const [reel4, setReel4] = useState(initialSymbols());
    const [spinning, setSpinning] = useState(false);
    const [reelsTextMap, setReelsTextMap] = useState(new Map());
    const [reelResult, setReelResult] = useState([]);
    const [resetKey, setResetKey] = useState(0);
    const [ssTextMap, setSsTextMap] = useState(new Map());
    const [ss, setSs] = useState('')
    const [reelFix, setReelFix] = useState(false);

    const resetChild = () => {
        setResetKey(prevKey => prevKey + 1);
    };
    const handleCheckboxChange = (event) => {
        setReelFix(event.target.checked);
    };

    useEffect(() => {
        // 初期表示時にjsonデータを読み込む
        const map = new Map();
        for (let reel in reelsText) {
            for (let symbol in reelsText[reel]) {
                map.set(`${reel}_${symbol}`, reelsText[reel][symbol]);
            }
        }
        setReelsTextMap(map);
        const ssMap = new Map();
        for (let key in ssText) {
            ssMap.set(`${key}`, ssText[key]);
        }
        setSsTextMap(ssMap);
    }, []);

    const spin = () => {
        const nextSymbols = [
            generateSymbols(reelFix),
            generateSymbols(reelFix),
            generateSymbols(),
            generateSymbols()
        ]
        setReel1(nextSymbols[0]);
        setReel2(nextSymbols[1]);
        setReel3(nextSymbols[2]);
        setReel4(nextSymbols[3]);

        setSpinning(true);
        setReelResult(payline(nextSymbols));
        setSs(paylineSs(nextSymbols));
        resetChild();

        const reelElements = document.querySelectorAll('.reel');
        reelElements.forEach(reel => {
            reel.style.transform = 'translateY(0px)';
        });
        setTimeout(() => {
            reelElements.forEach(reel => {
                reel.style.transform = 'translateY(-2255px)';
            });
            setSpinning(false);
        }, 1000);
    };
    const defaultTheme = createTheme();

    return (
        <ThemeProvider theme={defaultTheme}>
            <GlobalStyles styles={{ ul: { margin: 0, padding: 0, listStyle: 'none' } }} />
            <CssBaseline />
            <AppBar
                position="static"
                color="default"
                elevation={0}
                sx={{ borderBottom: (theme) => `1px solid ${theme.palette.divider}` }}
            >
                <Toolbar sx={{ flexWrap: 'wrap' }}>
                    <Typography variant="h8" color="inherit" noWrap sx={{ flexGrow: 1 }}>
                        エルリスロットマシン ニイハチ#02ver.
                    </Typography>
                </Toolbar>
            </AppBar>
            <Container disableGutters maxWidth="sm" component="main" sx={{ pt: 3, pb: 2 }}>
            <div className="slotMachine">
                <div className="atari">▶</div>
                <Reel reelId="1" symbols={reel1} spinning={spinning} reelsTextMap={reelsTextMap}/>
                <Reel reelId="2" symbols={reel2} spinning={spinning} reelsTextMap={reelsTextMap}/>
                <Reel reelId="3" symbols={reel3} spinning={spinning} reelsTextMap={reelsTextMap} />
                <Reel reelId="4" symbols={reel4} spinning={spinning} reelsTextMap={reelsTextMap} />
                <div className="atari">◀</div>

                <div className="mask">
                    <SpinButton onClick={spin} spinning={spinning}/>
                    <Checkbox
                        onChange={handleCheckboxChange}
                        label={{ 'aria-label': 'primary checkbox' }}
                    />ノビ高固定
                    <br/>
                    <CommentArea reelResult={reelResult} spinning={spinning} key={resetKey} ss={ss}/>
                </div>
            </div>
            </Container>
            <Container maxWidth="sm" >
                <Copyright sx={{ mt: 1 }} />
            </Container>
        </ThemeProvider>
    );
}

export default SlotMachine;
